<template>
  <el-dialog title="企业详情" :visible.sync="open_add" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
    <div class="company-detail">
      <div class="section-title">组织基本信息</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="组织类型">{{ detail.organization_type || '-' }}</el-descriptions-item>
       
        <el-descriptions-item label="组织名称">{{ detail.organization_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="简称">{{ detail.short_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="组织状态">{{ detail.status_text || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否开通站点">{{ detail.is_open_site == 1 ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="安全负责人">{{ detail.safety_manager || '-' }}</el-descriptions-item>
        <el-descriptions-item label="安全负责人电话">{{ detail.safety_manager_phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.create_time || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detail.create_user || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照住所" :span="2">{{ detail.business_license_address || '-' }}</el-descriptions-item>
        <el-descriptions-item label="监管组织" :span="2">{{ detail.supervision_organization || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="section-title">管理员信息</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="姓名">{{ detail.admin_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="账号">{{ detail.admin_account || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{ detail.admin_phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="监管平台主账号">{{ detail.main_account || '-' }}</el-descriptions-item>
        <el-descriptions-item label="角色">{{ detail.role_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="原组织编码">{{ detail.original_org_code || '-' }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ detail.admin_email || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="section-title">业务权限信息</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="营业执照">
          <div v-if="detail.business_license_image && detail.business_license_image.length > 0">
            <img v-for="(img, index) in detail.business_license_image" :key="index" :src="img.file_path" style="width: 100px; height: 100px; margin-right: 10px;" @click="previewImage(img.file_path)">
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="营业执照名称">{{ detail.business_license_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="注册资本">{{ detail.registered_capital || '-' }}</el-descriptions-item>
        <el-descriptions-item label="法定代表人">{{ detail.legal_representative || '-' }}</el-descriptions-item>
        <el-descriptions-item label="法定代表人身份证号">{{ detail.legal_id_card || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照住所" :span="2">{{ detail.business_license_address || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照经营范围" :span="2">{{ detail.business_license_scope || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="section-title">道路运输经营许可证</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="发证日期">{{ detail.transport_license_issue_date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="道路运输经营范围" :span="2">{{ detail.transport_license_scope || '-' }}</el-descriptions-item>
        <el-descriptions-item label="统一社会信用代码">{{ detail.credit_code || '-' }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ detail.company_type || '-' }}</el-descriptions-item>
        <el-descriptions-item label="成立日期">{{ detail.establishment_date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="法定代表人电话">{{ detail.legal_phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="有效期">
          <span v-if="detail.transport_license_validity_start && detail.transport_license_validity_end">
            {{ detail.transport_license_validity_start }} 至 {{ detail.transport_license_validity_end }}
          </span>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="许可证图片" :span="2">
          <div v-if="detail.transport_license_image && detail.transport_license_image.length > 0">
            <img v-for="(img, index) in detail.transport_license_image" :key="index" :src="img.file_path" style="width: 100px; height: 100px; margin-right: 10px;" @click="previewImage(img.file_path)">
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关 闭</el-button>
    </div>

    <el-dialog title="图片预览" :visible.sync="previewVisible" width="600px">
      <img :src="previewImageUrl" style="width: 100%; max-height: 500px;">
    </el-dialog>
  </el-dialog>
</template>

<script>
import Ma_companyApi from '@/api/ma_company.js';

export default {
  name: 'CompanyDetail',
  props: {
    open_add: {
      type: Boolean,
      default: false
    },
    ma_company_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      detail: {},
      previewVisible: false,
      previewImageUrl: ''
    };
  },
  created() {
    console.log('Detail component created');
    console.log('ma_company_id:', this.ma_company_id);
    console.log('open_add:', this.open_add);
    if (this.ma_company_id || this.ma_company_id === 0) {
      console.log('Calling getDetail from created');
      this.getDetail();
    }
  },
  watch: {
    open_add(newVal) {
      console.log('open_add changed:', newVal, 'ma_company_id:', this.ma_company_id);
      if (newVal && this.ma_company_id) {
        this.getDetail();
      }
    },
    ma_company_id(newVal) {
      console.log('ma_company_id changed:', newVal);
      if (newVal) {
        this.getDetail();
      }
    }
  },
  methods: {
    dialogFormVisible() {
      this.$emit('close');
    },

    closeDialog() {
      this.$emit('close');
    },

    getDetail() {
      console.log('getDetail called, ma_company_id:', this.ma_company_id);
      let self = this;
      Ma_companyApi.detail({ ma_company_id: this.ma_company_id }, true)
        .then(res => {
          console.log('getDetail response:', res);
          self.detail = res.data;
          self.detail.transport_license_image = res.data.transport_license_image || [];
          self.detail.business_license_image = res.data.business_license_image || [];
        })
        .catch(error => {
          console.error('getDetail error:', error);
          self.$message.error('获取详情失败');
        });
    },

    openDetail(row) {
      this.detail = row;
      this.dialogVisible = true;
    },

    previewImage(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    }
  }
};
</script>

<style scoped>
.company-detail {
  padding: 20px 0;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 20px 0 10px 0;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
}

.company-detail .el-descriptions {
  margin-bottom: 20px;
}

.company-detail .el-descriptions-item__label {
  width: 150px;
  font-weight: bold;
}

.company-detail img {
  cursor: pointer;
  transition: all 0.3s;
}

.company-detail img:hover {
  transform: scale(1.05);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_company/index/part/detail.vue